module.exports = __webpack_public_path__ + "static/Corona-Banner-Undermaintenance.d8c92bf8.jpg";